import { createFileRoute, useRouter, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { SellTable } from '@/components/Pages/Sells/SellTable';
import { Box, Button } from '@mui/joy';
import { Add as AddIcon } from '@mui/icons-material';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/sells/')({
  component: SellsPage,
  head: () => pageTitle('Ventas'),
});

function SellsPage() {
  const router = useRouter();
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('SELLS_READ');
  const canWrite = hasClaim('SELLS_WRITE');

  const handleCreateSell = () => {
    router.navigate({ to: '/sells/create' });
  };

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        {canWrite && (
          <Button
            startDecorator={<AddIcon />}
            onClick={handleCreateSell}
            variant='outlined'
            color='neutral'
          >
            Crear venta
          </Button>
        )}
      </Box>

      <SellTable />
    </Box>
  );
}
